import { motion } from "framer-motion";
import { Crosshair, Sparkles, CalendarCheck, BadgeEuro, Shuffle, Wrench } from "lucide-react";
import { WHY_FEATURES } from "../lib/data";

const ICONS = { Crosshair, Sparkles, CalendarCheck, BadgeEuro, Shuffle, Wrench };

export default function WhyGrid() {
  return (
    <section id="warum" className="relative py-20 md:py-28 bg-ink" data-testid="why-grid-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-5">
            <span className="h-px w-12 bg-volt/50" />
            <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-volt">Ihre Vorteile</span>
            <span className="h-px w-12 bg-volt/50" />
          </div>
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-white leading-[0.95]">
            Warum <span className="text-volt">VoltCore?</span>
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div key={f.title} data-testid={`why-feature-${f.title}`}
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                className="group relative rounded-2xl bg-ink-surface border border-white/[0.06] p-8 hover:border-volt transition-all duration-500 hover:-translate-y-1.5">
                <span className="grid place-items-center h-14 w-14 rounded-xl bg-volt/10 text-volt group-hover:bg-volt group-hover:text-black transition-all duration-500">
                  <Icon className="h-6 w-6" strokeWidth={2} />
                </span>
                <h3 className="mt-6 font-heading font-bold text-xl text-white">{f.title}</h3>
                <p className="mt-2.5 text-white/55 text-sm leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
